import { render, staticRenderFns } from "./c_txt_tab.vue?vue&type=template&id=b5804674&scoped=true&"
import script from "./c_txt_tab.vue?vue&type=script&lang=js&"
export * from "./c_txt_tab.vue?vue&type=script&lang=js&"
import style0 from "./c_txt_tab.vue?vue&type=style&index=0&id=b5804674&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5804674",
  null
  
)

export default component.exports